import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { JourneyType } from '../../../../__generated__/globalTypes';
import { Routes } from '../../../../common/enum/Routes';
import { UrlParamTypes } from '../../../../common/enum/UrlParamTypes';
import PAYMENT_TYPE from '../../../common/constants/paymentType';
import usePlatformConfig from '../../../../common/react/usePlatformConfig';
import collectedFilters from '../../../../common/service/collectedFilters';
import { useLocation } from 'react-router-dom';

const useEnquiryNextStep = (journeyType: JourneyType) => {
  const history = useHistory();
  const {
    platformConfig: { paymentProvider },
  } = usePlatformConfig();
  const {
    filters: { token },
  } = collectedFilters();
  const location = useLocation();

  const isPaymentEnabled =
    journeyType === JourneyType.reserve_online &&
    [PAYMENT_TYPE.WEBPAY, PAYMENT_TYPE['2C2P'], PAYMENT_TYPE.VISANET, PAYMENT_TYPE.MERCADOPAGO].includes(
      paymentProvider,
    );
  const pathname = !!isPaymentEnabled ? Routes.PAYMENT : Routes.CONFIRMATION_REQUEST_QUOTE;

  const goToNextStep = useCallback(
    (data?: Record<string, []>) => {
      history.push({
        ...location,
        pathname,
        search: `?${UrlParamTypes.TOKEN}=${token}`,
        state: {
          from: location.pathname,
          previousTransactions: data?.previousTransactions,
        },
      });
    },
    [token],
  );

  return { goToNextStep };
};

export default useEnquiryNextStep;
